/* eslint-disable no-useless-catch */
/* eslint-disable unused-imports/no-unused-vars */
import { RTS_FILE_UPLOAD, RTS_REQUEST_URL } from "../constants/url.constant";

import { API } from "../api";

export const GET_ALL_RTS_REQUEST = "GET_ALL_RTS_REQUEST";
export const DELETE_RTS_REQUEST = "DELETE_RTS_REQUEST";

export const uploadAWBFile = (fileData) => {
  return async (dispatch) => {
    try {
      return await API.post(RTS_FILE_UPLOAD, fileData);
    } catch (error) {
      throw error;
    }
  };
};

export const createRTSRequest = (data) => {
  return async (dispatch) => {
    try {
      const res = await API.post(RTS_REQUEST_URL, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getAllRTSRequest = (params = {}) => {
  return async (dispatch) => {
    try {
      const res = await API.get(RTS_REQUEST_URL, {
        params: params
      });
      dispatch({
        type: GET_ALL_RTS_REQUEST,
        payload: res
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const getRTSRequestById = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.get(`${RTS_REQUEST_URL}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const updateRTSRequest = (id, data) => {
  return async (dispatch) => {
    try {
      const res = await API.put(`${RTS_REQUEST_URL}/${id}`, data);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeRTSRequestOrder = (orderId, id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${RTS_REQUEST_URL}/${orderId}/${id}`);
      return res;
    } catch (error) {
      throw error;
    }
  };
};

export const removeRTSRequest = (id) => {
  return async (dispatch) => {
    try {
      const res = await API.delete(`${RTS_REQUEST_URL}/${id}`);
      dispatch({
        type: DELETE_RTS_REQUEST,
        payload: id
      });
      return res;
    } catch (error) {
      throw error;
    }
  };
};

const initialState = {
  columns: [],
  data: [],
  totalRows: 0,
  order: {}
};

export default function reducer(state = initialState, { type, payload }) {
  switch (type) {
    case GET_ALL_RTS_REQUEST:
      return {
        ...state,
        columns: payload.columns,
        data: payload.rows,
        totalRows: payload.count
      };
    case DELETE_RTS_REQUEST:
      return {
        ...state,
        totalRows: state.totalRows - 1,
        data: state.data.filter((bag) => bag.id !== payload)
      };
    default:
      return state;
  }
}
